import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaWhatsapp, FaInstagram, FaFileAlt } from 'react-icons/fa';
import { siteConfig } from '../data/site';

const Contato = () => {
  const handleWhatsApp = () => {
    const message = encodeURIComponent(
      'Olá! Gostaria de solicitar um orçamento para desenvolvimento de site institucional.'
    );
    window.open(`https://wa.me/${siteConfig.whatsappNumber}?text=${message}`, '_blank');
  };

  return (
    <section id="contato" className="relative py-32 overflow-hidden transition-colors duration-500">
      <div className="absolute inset-0 hero-gradient opacity-90" />
      <div className="absolute inset-0 bg-dark-bg/60" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="gsap-reveal mb-12">
          <p className="text-burnt font-heading font-semibold uppercase tracking-wider text-sm mb-4">
            Vamos conversar?
          </p>
          <h2 className="text-4xl md:text-6xl font-heading font-bold text-white mb-6 leading-tight">
            Pronto para ter um site<br />
            <span className="text-burnt">profissional</span>?
          </h2>
          <p className="text-xl text-cream/80 max-w-2xl mx-auto font-body">
            Solicite um orçamento gratuito. Suporte direto, sem intermediários — você fala com quem executa.
          </p>
        </div>

        <motion.button
          onClick={handleWhatsApp}
          className="btn-premium gsap-reveal inline-flex items-center gap-4 bg-[#25D366] hover:bg-[#20BD5A] text-white px-10 py-5 rounded-2xl font-semibold text-xl transition-all duration-300 shadow-lg"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.98 }}
          data-cursor="pointer"
        >
          <FaWhatsapp className="text-2xl" />
          Solicitar Orçamento via WhatsApp
        </motion.button>

        <div className="gsap-reveal mt-6">
          <p className="text-cream/70 text-sm font-body mb-4">
            Prefere responder por aqui?
          </p>
          <Link
            to="/orcamento"
            className="inline-flex items-center gap-3 px-8 py-4 rounded-2xl font-semibold text-base text-white border border-white/30 hover:border-burnt hover:bg-burnt/10 transition-all duration-300"
            data-cursor="pointer"
          >
            <FaFileAlt />
            Preencher formulário de orçamento
          </Link>
        </div>

        <p className="gsap-reveal mt-8 text-cream/60 text-sm font-body">
          Respondo em até 24 horas · {siteConfig.whatsappDisplay}
        </p>

        <a
          href={siteConfig.instagramUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="gsap-reveal inline-flex items-center gap-2 mt-4 text-cream/70 hover:text-burnt transition-colors font-body text-sm"
          data-cursor="pointer"
        >
          <FaInstagram />
          {siteConfig.instagramHandle}
        </a>
      </div>
    </section>
  );
};

export default Contato;
